const theme = {
  title: "light",
  colors: {
    primary: "#ffffff",
    secondary: "#121214",
    text: "#121214",
    neutral: "#D9D9D9",
    transparenceBar: "rgba(217, 217, 217,1)",
    transparenceBarHover: "rgba(0, 0, 0,0.5)",
    navBar: "rgba(255, 255, 255,0.95)",
    filter: "invert(1)",
  },
};

export default theme;
